function navbar_scroll() {
    var last_scroll_top = 0;
    jQuery(window).on('scroll', function () {
        var scroll_top = jQuery(this).scrollTop();
        if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
            if (scroll_top < last_scroll_top) {
                jQuery('#main-nav').removeClass('scrolled-down addpadding').addClass('scrolled-up shadow');
            } else {
                jQuery('#main-nav').removeClass('scrolled-up').addClass('scrolled-down');
            }
        } else if (document.body.scrollTop == 0) {
            jQuery('#main-nav').removeClass('shadow').addClass('addpadding');
        } else {
            jQuery('#main-nav').removeClass('scrolled-down addpadding').addClass('scrolled-up');
        }
        last_scroll_top = scroll_top;
    });
}

function backToTop() {
    if (jQuery(window).scrollTop() >= 200) {
        jQuery("#go-top").fadeIn(200);
    } else {
        jQuery("#go-top").fadeOut(200);
    }
};

// https://benfrain.com/automatically-play-and-pause-video-as-it-enters-and-leaves-the-viewport-screen/
function playPauseVideo() {
    let videos = document.querySelectorAll("video");
    videos.forEach((video) => {
        // We can only control playback without insteraction if video is mute
        video.muted = true;
        // Play is a promise so we need to check we have it
        let playPromise = video.play();
        if (playPromise !== undefined) {
            playPromise.then((_) => {
                let observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.intersectionRatio !== 1 && !video.paused) {
                                video.pause();
                                console.log('video is playing');
                            } else if (video.paused) {
                                video.play();
                                console.log('video is pausing');
                            }
                        });
                    },
                    { threshold: 0.2 }
                );
                observer.observe(video);
            });
        }
    });
}

var element, bgColor, brightness, r, g, b, hsp;

function lightOrDark(color) {
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
        // If HEX --> store the red, green, blue values in separate variables
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        r = color[1];
        g = color[2];
        b = color[3];
    }
    else {
        // If RGB --> Convert it to HEX: http://gist.github.com/983661
        color = +("0x" + color.slice(1).replace(
            color.length < 5 && /./g, '$&$&'
        )
        );
        r = color >> 16;
        g = color >> 8 & 255;
        b = color & 255;
    }
    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b)
    );
    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) {
        return 'light';
    }
    else {
        return 'dark';
    }
}


jQuery(window).on('scroll', function () {
    backToTop();
});

jQuery(document).ready(function ($) {
    navbar_scroll();
    playPauseVideo();

    $(".colorbio").each(function () {
        var bgColor = $(this).css("background-color");
        var brightness = lightOrDark(bgColor);
        if (brightness == 'dark') {
            $(this).find('p, h1, h5, a').addClass('text-white');
        } else {
            $(this).find('p, h1, h5, a').addClass('text-primary');
        }
    });
})